<template>
  <div class="catalog">
    <div class="card flex justify-content-center">
        <p class="catalog__title">Направление деятельности:</p>
        <Dropdown
          v-model="selectedActivity"
          inputId="activity"
          :options="productsActivity"
          optionLabel="Description"
          placeholder="Выберите направление деятельности"
        />
    </div>
    <div class="catalog__category" v-if="selectedActivity !== null">
      <draggable
        class="catalog__category-list"
        v-model="selectedActivity.Childs"
        draggable="false"
      >
        <template #item="{element}">
          <CategoryItem
            :key="idx"
            :name="element.Name"
            :active="element.Id === activeTab ? true : false"
            :changeName="isActiveCategory != element.Id"
            @editCategoryName="canEdit(element.Id)"
            @clickCategory="chooseCategory(element.Id)"
            @deleCategory="deleteCategory(element.Id)"
            @renameCategory="newNameCategory"
            @reset="resetEdit"
          />
        </template>
      </draggable>
      <ToolbarIcons typeImg='plus' @clickIcon="addCategory"/>
    </div>

    <draggable
      class="wrapper"
      v-model="productsDataList"
      @change="moveProductsList($event, 0)"
    >
      <template #item="{element}">
        <div class="product">
          <div class="product__header">
            <div class="product__header-name">
              <div class="product__header-title" v-if="isActiveSubcategory != element.UniversalTagId">{{element.UniversalTagName}}</div>
              <InputText
                v-if="isActiveSubcategory == element.UniversalTagId"
                :value="element.UniversalTagName"
                :disabled="isActiveSubcategory != element.UniversalTagId"
                @input="newNametag"
              />
            </div>
            <div class="product__header-editor">
              <div class="product__header-icon">
                <ToolbarIcons
                  typeImg='edit'
                  @clickIcon="ediitNameSubcategory(element.UniversalTagId)"
                  v-if="isActiveSubcategory != element.UniversalTagId"
                />
                <ToolbarIcons
                  typeImg='done'
                  v-if="isActiveSubcategory == element.UniversalTagId"
                  @clickIcon="SaveNameSubcategory(element.UniversalTagId)"
                />
                <ToolbarIcons
                  typeImg='cancel'
                  v-if="isActiveSubcategory == element.UniversalTagId"
                  @clickIcon="сancelEdit"
                  red
                />
              </div>
              <div class="product__header-icon">
                <ToolbarIcons
                  typeImg='trash'
                  @clickIcon="deleteSubCategory(element.UniversalTagId
                  )"
                  red
                  v-if="isActiveSubcategory != element.UniversalTagId"
                />
              </div>
            </div>
          </div>

          <draggable
            v-if="element.Products.length != 0"
            class="product__list"
            v-model="element.Products"
            @change="moveProductsList($event, 1, element.UniversalTagId)"
          >
            <template #item="{element}">
              <div class="product__item">
                <p class="product__item-text" v-html="element.Name" />
                <div class="product__item-icons">
                  <ShowIcons
                    @visability="togglePublish(element.Id, element.Published)"
                    :visibility="element.Published"
                  />
                  <DeleteCategoryIcon @delete="deleteProduct(element.Id)"/>
                </div>
              </div>
            </template>
          </draggable>

          <div
            class="product__list"
          >
            <div class="product__item">
              <p class="product__item-text">Добавить товар в подкатегорию</p>
              <div class="product__item-icons">
                <DeleteCategoryIcon
                  add
                  @delete="addProductService(element.UniversalTagId)"
                />
              </div>
            </div>
          </div>
        </div>
        </template>
    </draggable>
    <div class="catalog__add" v-if="activeTab !== null" @click="addSubcategory">
      <DeleteCategoryIcon plus/>
      <p class="catalog__add-text">Добавить подкатегорию</p>
    </div>
  </div>
  <ConfirmDelete
    v-if="confirmationDeletion"
    @remove="remove"
    @cancel="confirmationDeletion = false"
  />
  <AddProductSubcategory
    v-if="ShowProductAdder"
    :productList="addProductsList"
    @cancel="showProductsList = false"
    :activityId="selectedActivity"
    :subcategoryId="idSubcategory"
    :categoryId="activeTab"
  />
</template>

<script>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'

import ConfirmDelete from '@/components/modals/ConfirmDelete'
import AddProductSubcategory from '@/components/modals/AddProductSubcategory'

import Dropdown from 'primevue/dropdown'
import draggable from 'vuedraggable'
import InputText from 'primevue/inputtext'
import CategoryItem from '@/components/ui/CategoryItem'

import ToolbarIcons from '@/components/icons/ToolbarIcons'
import DeleteCategoryIcon from '@/components/icons/DeleteCategoryIcon'
import ShowIcons from '@/components/icons/ShowIcons'
export default {
  name: 'ListProducts',
  components: {
    Dropdown,
    draggable,
    InputText,
    ConfirmDelete,
    CategoryItem,
    ToolbarIcons,
    DeleteCategoryIcon,
    ShowIcons,
    AddProductSubcategory
  },
  props: {
  },
  setup () {
    const store = useStore()
    const selectedActivity = ref(null)
    const activeTab = ref(null)
    const productsDataList = ref([])
    const confirmationDeletion = ref(false)
    const confirmDelete = ref(false)
    const idDeletElement = ref(null)
    const nameNewEditTag = ref('')
    const showProductsList = ref(false)
    const idSubcategory = ref(null)
    const isActiveSubcategory = ref(-1)
    const idCategory = ref(null)
    const isActiveCategory = ref(-1)
    const itemDelete = ref(0)

    const productsActivity = computed(() => {
      return store.getters.getActivityList
    })

    const productsData = computed(() => {
      return store.getters.getProductsListData
    })

    const addProductsList = computed(() => {
      return store.getters.getAddProductsListFiltered
    })

    const ShowProductAdder = computed(() => {
      return store.getters.getShowProductAdder
    })

    watch(productsData, (newData) => {
      productsDataList.value = newData
    })
    watch(selectedActivity, () => {
      productsDataList.value = null
      activeTab.value = null
    })

    watch(productsActivity, (newValue) => {
      if (selectedActivity.value) {
        const test = productsActivity.value.findIndex(item => {
          return item.Id === selectedActivity.value.Id
        })
        selectedActivity.value = productsActivity.value[test]
      }
    })

    const chooseCategory = (id) => {
      activeTab.value = id
      if (selectedActivity.value.Id === 3) {
        store.dispatch('SetA_ProductsListProduction', id)
      } else {
        store.dispatch('SetA_ProductsListServices', id)
      }
    }

    const togglePublish = (id, val) => {
      let obj = null
      if (selectedActivity.value.Id === 3) {
        obj = {
          Id: id,
          Value: !val,
          Active: activeTab?.value
        }
        store.dispatch('SetA_PublishProduct', obj)
      } else {
        obj = {
          Id: id,
          Value: !val,
          Active: activeTab?.value
        }
        store.dispatch('SetA_PublishService', obj)
      }
    }

    const moveProductsList = (evn, typeArry, id) => {
      if (selectedActivity.value.Id === 3) {
        store.commit('SetM_MoveProductsList', {
          itemId: id,
          evn: evn?.moved,
          type: typeArry
        })
      } else {
        store.commit('SetM_MoveServiceList', {
          itemId: id,
          evn: evn?.moved,
          type: typeArry
        })
      }
    }

    // const moveCategoryList = (evn) => {
    //   store.commit('SetM_MoveCategory', evn?.moved)
    // }

    const ediitNameSubcategory = (id) => {
      idSubcategory.value = id
      isActiveSubcategory.value = id
    }

    const resetEdit = () => {
      isActiveCategory.value = -1
    }

    const canEdit = (id) => {
      idCategory.value = id
      isActiveCategory.value = id
    }

    const сancelEdit = () => {
      isActiveSubcategory.value = -1
    }

    const newNametag = (e) => {
      nameNewEditTag.value = e.target.value
    }

    const SaveNameSubcategory = (id) => {
      isActiveSubcategory.value = -1
      let obj = null
      if (selectedActivity.value.Id === 3) {
        obj = {
          Id: id,
          Name: nameNewEditTag.value,
          ParentTagId: activeTab.value
        }
        store.dispatch('SetA_SaveNameCategoryProduct', obj)
      } else {
        obj = {
          Id: id,
          Name: nameNewEditTag.value,
          ParentTagId: activeTab.value
        }
        store.dispatch('SetA_SaveNameCategoryService', obj)
      }
    }

    const newNameCategory = (value) => {
      const obj = {
        Id: idCategory.value,
        Name: value.target.value
      }
      store.dispatch('SetA_SaveNameCategory', obj)
      isActiveCategory.value = -1
    }

    const addSubcategory = () => {
      let obj = null
      if (selectedActivity.value.Id === 3) {
        obj = {
          Name: 'Новая подкатегория',
          ParentTagId: activeTab.value,
          Description: ''
        }
        store.dispatch('SetA_AddSubcategoryProduction', obj)
      } else {
        obj = {
          Name: 'Новая подкатегория',
          ParentTagId: activeTab.value,
          Description: ''
        }
        store.dispatch('SetA_AddSubcategoryService', obj)
      }
    }

    const addCategory = () => {
      const obj = {
        Name: 'Новая категория',
        ParentTagId: selectedActivity.value.Id,
        Description: ''
      }
      store.dispatch('SetA_AddCategory', obj)
    }

    const addProductService = (id) => {
      store.commit('SetM_ShowProductAdder', true)
      idSubcategory.value = id
      if (selectedActivity.value.Id === 3) {
        store.dispatch('SetA_ListProduction')
      } else {
        store.dispatch('SetA_ListService')
      }
    }

    const deleteCategory = (id) => {
      confirmationDeletion.value = true
      idDeletElement.value = id
      itemDelete.value = 1
    }

    const deleteSubCategory = (id) => {
      confirmationDeletion.value = true
      idDeletElement.value = id
      itemDelete.value = 2
    }

    const deleteProduct = (id) => {
      confirmationDeletion.value = true
      idDeletElement.value = id
      itemDelete.value = 3
    }

    const remove = () => {
      let obj = null
      if (itemDelete.value === 1) {
        store.dispatch('SetA_DeleteCategory', idDeletElement.value)
        confirmationDeletion.value = false
      }
      if (itemDelete.value === 2) {
        if (selectedActivity.value.Id === 3) {
          obj = {
            Id: idDeletElement.value,
            Active: activeTab?.value
          }
          store.dispatch('SetA_DeleteSubCategoryProduction', obj)
        } else {
          obj = {
            Id: idDeletElement.value,
            Active: activeTab?.value
          }
          store.dispatch('SetA_DeleteSubCategoryService', obj)
        }
        confirmationDeletion.value = false
      }
      if (itemDelete.value === 3) {
        if (selectedActivity.value.Id === 3) {
          obj = {
            Id: idDeletElement.value,
            Active: activeTab?.value
          }
          store.dispatch('SetA_DeleteProductCategoryProduction', obj)
        } else {
          obj = {
            Id: idDeletElement.value,
            Active: activeTab?.value
          }
          store.dispatch('SetA_DeleteProductCategoryService', obj)
        }
        confirmationDeletion.value = false
      }
    }

    return {
      productsActivity,
      selectedActivity,
      productsData,
      productsDataList,
      ShowProductAdder,
      addProductsList,
      moveProductsList,
      // moveCategoryList,
      activeTab,
      resetEdit,
      isActiveSubcategory,
      chooseCategory,
      togglePublish,
      addSubcategory,
      addCategory,
      deleteSubCategory,
      deleteCategory,
      ediitNameSubcategory,
      showProductsList,
      сancelEdit,
      nameNewEditTag,
      canEdit,
      newNametag,
      newNameCategory,
      itemDelete,
      SaveNameSubcategory,
      confirmationDeletion,
      confirmDelete,
      addProductService,
      idSubcategory,
      isActiveCategory,
      idCategory,
      deleteProduct,
      remove
    }
  }
}
</script>

<style lang="scss" scoped>
.catalog {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  padding-bottom: 20px;

  &__title {
    font-weight: 500;
    font-size: 18px;
    text-align: left;
    margin-bottom: 8px;
  }

  &__category {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &-list {
      display: flex;
      flex-wrap: wrap;
      gap: 15px 30px;
    }
  }

  &__add {
    width: 270px;
    display: flex;
    align-items: center;
    padding: 12px 10px;
    background-color: #00ABEC;
    border-radius: 6px;
    cursor: pointer;
    transition: 0.8s;

    &:hover {
      background-color: #0080B0;
    }

    &:active {
      background-color: #006084;
    }

    &-text {
      margin-left: 8px;
      font-size: 18px;
      color: #FFFFFF;
    }
  }
}
:deep(.p-dropdown) {
  width: 800px;
}
:deep(.p-dropdown-label) {
  text-align: start;
}

.product {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #000000;
  :deep(.wrapper-icon) {
    width: 30px;
    height: 30px;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;

    &-name {
      width: max-content;

      :deep(.p-inputtext) {
        min-width: 600px;
        font-size: 18px;
        font-weight: 500;
        color: #000;
        &:disabled {
          opacity: 1;
          outline: none;
          border: none;
        }
      }
    }

    &-title {
      font-size: 18px;
      font-weight: 600;
      text-align: start;
    }

    &-editor {
      display: flex;
      gap: 10px;
      width: 40%;
    }

    &-icon {
      display: flex;
      gap: 5px;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-radius: 4px;
    text-align: start;
    color: #000000;
    font-weight: 400;
    font-size: 16px;
    border: 1px dashed #787878;
    cursor: pointer;
    transition: 0.5s;

    &:hover {
      background-color: #DEDEDE;
      color: #000;
      border: 1px solid #DEDEDE;
    }

    &:active {
      color: #fff;
      border: 1px solid #00ABEC;
      background-color: #00ABEC;
      cursor: grabbing;
    }

    &-icons {
      display: flex;
      gap: 12px;
      align-items: center;

      :deep(svg ) {
        path {
          stroke:#000000;
        }

        &:hover {
          path {
            stroke: #00ABEC;
          }
        }
      }
    }
  }
}
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

:deep(.p-dropdown) {
  &.p-focus {
    box-shadow: none !important;
    outline: none; /* опционально: убрать outline, если тоже мешает */
  }

  &:focus-visible {
    box-shadow: none !important;
    outline: none;
  }
}

:deep(.p-inputtext) {
  border: 1px solid #000000;
  // -webkit-box-shadow: inset 0 0 0 50px white;
}

:deep(.p-inputtext:enabled:hover) {
  border-color: #00ABEC;
}
:deep(.p-inputtext:disabled) {
  opacity: 0.5;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #00ABEC;
  border-color: #00ABEC;
  -webkit-box-shadow: inset 0 0 0 50px white;
}
</style>
